import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Ventas" },
  { label: "Venta Mensual",             icon: "fas fa-chart-line",  color: "#10b981", bg: "#f0fdf4", href: "/GraficaVentasMensualComparativa", desc: "Comparativa mensual",        perm: "menu_reportes" },
  { label: "Venta Mensual Vendedor",    icon: "fas fa-chart-bar",   color: "#3b82f6", bg: "#eff6ff", href: "/GraficaVentasMensualVendedor",    desc: "Ventas por vendedor",         perm: "menu_reportes" },
  { label: "Venta Estado",              icon: "fas fa-globe-americas", color: "#8b5cf6", bg: "#f5f3ff", href: "/GraficaVentasEstado",          desc: "Ventas por estado",           perm: "menu_reportes" },
  { label: "Desgloce Ventas",           icon: "fas fa-chart-bar",   color: "#a855f7", bg: "#faf5ff", href: "/GraficaVentasDesgloce",           desc: "Desglose de ventas",          perm: "menu_reportes" },
  { label: "Dashboard Ventas Tabla",    icon: "fas fa-list",        color: "#ec4899", bg: "#fdf2f8", href: "/DashboardVentasTabla",            desc: "Tabla resumen",               perm: "menu_reportes" },

  { type: "section", label: "Inventario y Sell-Thru" },
  { label: "Valor Inventario",          icon: "fas fa-money-check-alt", color: "#f59e0b", bg: "#fffbeb", href: "/ValorInventario", desc: "Valuación de inventario", perm: "menu_reportes" },
  { label: "Sell Thru",                 icon: "fas fa-search-dollar",   color: "#6366f1", bg: "#eef2ff", href: "/SellThru",        desc: "Rotación por artículo",   perm: "menu_reportes" },
  { label: "Sell Thru Area",            icon: "fas fa-search-dollar",   color: "#0891b2", bg: "#ecfeff", href: "/SellThruArea",    desc: "Rotación por área",       perm: "menu_reportes" },
];

function BotonesReportesVentas() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-line" color="#10b981" bg="#f0fdf4" title="Reportes Ventas" subtitle="Análisis de ventas e inventario" />
        {user.menu_reportes ? (
          <div className="row">
            {ITEMS.map((r, i) => {
              if (r.type === "section") return <MenuSection key={i} title={r.label} />;
              const enabled = r.permOr ? r.permOr.some((p) => !!user[p]) : !!user[r.perm];
              return <MenuCard key={i} {...r} enabled={enabled} />;
            })}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesReportesVentas;
